import { Contractor, ContractorStatus } from '@umss/shared/data-access';
import { ScopeOfPracticeEnum } from '@umss/shared/utils';

export const mockContractor: Contractor = {
  userId: 'e052a7db-3331-4482-a7cc-8fff85627700',
  user: {
    role: 'Contractor',
    isActive: true,
    emailVerified: false,
    lastLogin: '2025-12-26T17:38:25.169103Z',
    mustChangePassword: false,
    firstName: 'RT01',
    lastName: 'Manuel',
    email: 'contractorA10@gmail.com',
    phone: '',
    fullName: 'RT01 Manuel',
    id: 'e052a7db-3331-4482-a7cc-8fff85627700',
    createdAt: '2025-12-03T13:55:50.277331Z',
    updatedAt: '2025-12-03T13:55:52.853831Z'
  },
  licenseNumber: '',
  scopeOfPractice: ScopeOfPracticeEnum.Rn,
  scopeOfPracticeDisplay: 'Bsn',
  status: ContractorStatus.Active,
  statusDisplay: '',
  maxDriveTimeMinutes: 60,
  profilePictureUrl: '',
  bio: '',
  preferredBasePayRate: 18,
  urgentNeedsPayRate: 20,
  isAvailable: true,
  isVerified: false,
  backgroundCheckCompleted: false,
  onboardingCompleted: false,
  reviewCount: 0,
  totalShiftsCompleted: 0,
  totalHoursWorked: 0,
  isFavorite: false,
  distanceMiles: 25,
  id: '4e9ebd26-b643-4442-a882-c513c1493dbc',
  createdAt: '2025-12-03T13:55:51.007606Z',
  updatedAt: '2025-12-26T18:01:34.483562Z'
};
